module.exports = __webpack_public_path__ + "img/summary-optimization.c95bbe64.png";